import gql from 'graphql-tag'

export const TOGGLE_HIDDEN_FIELD = gql`
	mutation toggleHiddenField($id: ID, $fieldId: ID!, $teamId: ID!, $recordId: ID!, $deleted: Boolean!) {
		hiddenField_Update(input: {
			id: $id,
			field: $fieldId,
			deleted: $deleted,
			team: $teamId
		}) {
			object {
				id
				field {
					id
					hiddenFieldId(recordId: $recordId)
				}
				deleted
			}
			errors {
				field
				messages
			}
		}
	}
`
